const DynamicPasskeyWidgetViews = ['manage-passkeys'];
const DynamicTransactionsWidgetViews = ['send-balance'];

export { DynamicPasskeyWidgetViews, DynamicTransactionsWidgetViews };
